import './Statistics.css';
import { useState, useEffect, ReactNode } from 'react'
import { Button, Form } from "react-bootstrap";
import SettingsHeader from '../console/SettingsHeader';
import { APIRequestGet, APIRequestPost } from '../../utils/APIRequests';
import { ModemStatisticSchema, StatisticSetModemCommentRequestData } from '../../api/Statistic';
import {
    AstraAdminSubscriptionData,
    AstraAdminSubscriptionProlongationRequestData,
    AstraAdminSubscriptionSchema
} from '../../api/AstraAdminSubscription';
import { FlightLogGetFlightLogsRequestData, MultipleFlightLogsSchema } from '../../api/FlightLog';
import axios from 'axios';

interface ModemStatisticData {
    imei: string;
    userName: string;
    comment: string;
    lifetime: number;
    name: string;
    version: string;
    statId: string;
}

interface FlightLog {
    fileName: string;
    fileSize: number;
    logId: string;
}

const ModemStatistic = (): ReactNode => {
    const [info, setInfo] = useState<ModemStatisticData>();
    const [comment, setComment] = useState<string>("");
    const [flightLogs, setFlightLogs] = useState<FlightLog[]>([]);
    const [logPage, setLogPage] = useState<number>(0);
    const [subscription, setSubscription] = useState<AstraAdminSubscriptionData>();
    const [prolongationDays, setProlongationDays] = useState<number>(30);

    const queryParams = new URLSearchParams(window.location.search);
    const isAstra = process.env.REACT_APP_SERVICE === 'astra';
    const [isProlongation, setIsProlongation] = useState(false);

    function getModemStatistic() {
        const imei = queryParams.get("imei");

        APIRequestGet(`/statistic/getModemStatistic?imei=${imei}`, {
            schema: ModemStatisticSchema,
            logSuccess: true
        }).then((result) => {
            setInfo(result.data);
            setComment(result.data.comment);
        });

        APIRequestGet(`/astraAdminSubscription/getByImei?imei=${imei}`, {
            schema: AstraAdminSubscriptionSchema,
            logSuccess: true
        }).then((result) => {
            setSubscription(result.data);
        });
    }

    function getFlightLogs(page: number) {
        const data: FlightLogGetFlightLogsRequestData = {
            imei: queryParams.get("imei") ?? "",
            page: page,
            count: 50
        };

        APIRequestPost('/flightLog/getFlightLogs', {
            data: data,
            schema: MultipleFlightLogsSchema,
            logSuccess: true
        }).then((result) => {
            setFlightLogs(result.data.flightLog);
        });
    }

    function logPageUp() {
        const lp = logPage + 1
        setLogPage(lp)
        getFlightLogs(lp)
    }

    function logPageDown() {
        const lp = logPage - 1
        setLogPage(lp)
        getFlightLogs(lp)
    }

    function downloadLog(logId: string, fileName: string) {
        const imei = queryParams.get("imei")
        axios({
            url: '/api/flightLog/download?logId=' + logId + "&imei=" + imei,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        });
    }

    function saveComment() {
        const data: StatisticSetModemCommentRequestData = {
            comment: comment,
            statId: info?.statId ?? ""
        };

        APIRequestPost('/statistic/setModemComment', {
            data: data,
            logSuccess: true
        });
    }

    function prolongation() {
        // Пустое поле даёт Number("") === 0: продление на 0 дней перепишет
        // TimeDeactivation, поэтому такой запрос отправлять нельзя.
        if (!Number.isFinite(prolongationDays) || prolongationDays <= 0) {
            return;
        }

        const data: AstraAdminSubscriptionProlongationRequestData = {
            days: prolongationDays,
            imei: queryParams.get("imei") ?? ""
        };

        setIsProlongation(true);
        APIRequestPost('/astraAdminSubscription/prolongation', {
            data: data,
            logSuccess: true
        }).then(() => {
            window.location.reload();
        }).finally(() => setIsProlongation(false));
    }

    useEffect(() => {
        console.log("statistic mount");
        getModemStatistic()
        getFlightLogs(logPage)
    }, []);

    return (
        <>
            <SettingsHeader />
            <div className='max-width text-page-padding'>
                {info &&
                    <table
                        className='table table-striped'
                        aria-labelledby="tableLabel"
                        style={{ tableLayout: "fixed" }}
                    >
                        <thead>
                            <tr>
                                <th style={{ width: "15%" }}>IMEI</th>
                                <th style={{ width: "17%" }}>User</th>
                                <th style={{ width: "30%" }}>Comment</th>
                                <th style={{ width: "15%" }}>Lifetime min</th>
                                <th style={{ width: "8%" }}>ID</th>
                                <th style={{ width: "10%" }}>Version</th>
                                <th style={{ width: "8%" }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={info.imei}>
                                <td>{info.imei}</td>
                                <td>{info.userName}</td>
                                <td style={{ fontSize: "15px" }}>
                                    <Form.Control
                                        type="text"
                                        defaultValue={comment}
                                        onChange={(event) => { setComment(event.target.value) }}
                                    />
                                </td>
                                <td>{info.lifetime.toFixed(2)}</td>
                                <td>{info.name}</td>
                                <td>{info.version}</td>
                                <td>
                                    <button
                                        style={{ width: "100%" }}
                                        className="btn btn-danger"
                                        onClick={() => { saveComment(); }}
                                    >
                                        Save
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                }
                <p>Subscription:</p>
                {(isAstra && subscription != null) &&
                    <table
                        className='table table-striped'
                        aria-labelledby="tableLabel"
                        style={{ tableLayout: "fixed" }}
                    >
                        <thead>
                            <tr>
                                <th style={{ width: "30%" }}>Time create</th>
                                <th style={{ width: "30%" }}>Time deactivation</th>
                                <th style={{ width: "30%" }}>Prolongation days</th>
                                <th style={{ width: "30%" }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{subscription.timeCreate}</td>
                                {subscription.isRotten ? (
                                    <td style={{ color: "red" }}>{subscription.timeDeactivation}</td>
                                ) : (
                                    <td>{subscription.timeDeactivation}</td>
                                )}
                                <td style={{ fontSize: "15px" }}>
                                    <Form.Control
                                        type="number"
                                        defaultValue={prolongationDays}
                                        onChange={(event) => { setProlongationDays(Number(event.target.value)) }}
                                    />
                                </td>
                                <td>
                                    <button
                                        style={{ width: "100%" }}
                                        className="btn btn-danger"
                                        disabled={isProlongation || !Number.isFinite(prolongationDays) || prolongationDays <= 0}
                                        onClick={() => { prolongation(); }}
                                    >
                                        Prolongation
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                }
                <p>Logs:</p>
                {flightLogs &&
                    <table
                        className='table table-striped'
                        aria-labelledby="tableLabel"
                        style={{ tableLayout: "fixed" }}
                    >
                        <thead>
                            <tr>
                                <th style={{ width: "40%" }}>File name</th>
                                <th style={{ width: "17%" }}>Size</th>
                                <th style={{ width: "10%" }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {flightLogs.map(l =>
                                <tr key={l.fileName}>
                                    <td>{l.fileName}</td>
                                    <td>{l.fileSize === 0 ? "undefined" : (l.fileSize / 1024 / 1024).toFixed(4) + " MB"}</td>
                                    <td>
                                        <button
                                            style={{ width: "100%" }}
                                            className="btn btn-danger"
                                            onClick={() => { downloadLog(l.logId, l.fileName); }}
                                        >
                                            Download
                                        </button>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                }

                <div className='nav-buttons'>
                    <Button disabled={logPage <= 0} onClick={logPageDown}>{logPage}</Button>
                    <div style={{ alignItems: "center", justifyItems: "center", display: "flex", width: "100%", marginLeft: "40px" }}>{logPage + 1}</div>
                    <Button onClick={logPageUp}>{logPage + 2}</Button>
                </div>
            </div>
        </>
    )
}

export default ModemStatistic;